import React, { Component } from 'react';
import {
    Container,
    Jumbotron,
    Button
} from 'reactstrap';

export default class Home extends Component {
  render() {
    return (
      <div>
        <Jumbotron className="text-center">
            <h1>Cleaning Service Belton</h1>
            <hr/>
            <h2>Brisk Cleaning Service <br/>What sort of cleaning are you interested in?</h2>
            
            
        <div className="row">
                <div className="col-md-4">
                    <h3>Move Out Cleaning?</h3>
                    <a href="https://www.briskcleaningservice.com/move-in-move-out"><img src="/images/move.jpeg" alt="move in move out" title="move in/move out" className="img-fluid"/></a>
                </div>
                <div className="col-md-4">
                    <h3>Professional Window Cleaning?</h3>
                    <a href="https://www.briskcleaningservice.com/window-cleaning"><img src="/images/window.jpg" alt="move in move out" title="move in/move out" className="img-fluid"/></a>
                </div>
                <div className="col-md-4">
                    <h3>Carpet Stain Removal?</h3>
                    <a href="https://www.briskcleaningservice.com/carpet-stain-removal"><img src="/images/carpet.jpg" alt="move in move out" title="move in/move out" className="img-fluid"/></a>
                </div>
            </div>
            <Container id="bottomPic" className="container-fluid text-center">
            <div className="resp-container">
                <iframe className="resp-iframe" width="560" height="315" src="https://www.youtube.com/embed/tMqOTzCgRoc" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
            </div>
            
            </Container>
            
        </Jumbotron>
        
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Home.js